import { Box, Typography } from '@mui/material'

interface Props {
  yearLabel?: string | null
}

export const AwaitingInvitation = ({ yearLabel }: Props): JSX.Element => {
  return (
    <Box data-testid='p2pAwaitingInvitation' sx={{ mt: '16px' }}>
      <Typography variant='h3' mb='8px'>Awaiting invitation{yearLabel != null ? ` for ${yearLabel}` : ''}</Typography>
      <Typography variant='body1'>
        You do not currently have an active invitation to report peer-to-peer program data
        {yearLabel != null ? ` for ${yearLabel}` : ''}. Access is granted each year by invitation from
        your ISD administrator. Please contact your ISD administrator if you believe you should have access.
      </Typography>
    </Box>
  )
}
